import { render, staticRenderFns } from "./TicketsListUsers.vue?vue&type=template&id=f4828808&"
import script from "./TicketsListUsers.vue?vue&type=script&lang=js&"
export * from "./TicketsListUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports